import React, { useRef, useState, useEffect } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Input,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/oralbook/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.oralbook.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_ASYNC]: { done: this._handleSaveAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        if (id)
            this.props.loadScreenViewAsync(id);
        else
            this.props.create();
    }

    render() {
        const { book } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!book || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    book={book}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSave}
                                    isDisabled={this.isActionExecuting(ActionTypes.SAVE_ASYNC)}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSave = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: this.props.partnerId, type: 1, chineseLevel: data.chineseLevelInput || data.chineseLevel }
                        this.props.saveAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveAsyncDone = (action) => {
        const { id } = action.data;
        NavigationService.navigateToPage(this, `/admin/oralbook/${id}/details`);
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { book } = props;
    const { id, title, sectionType, chineseLevel, visibility } = book;
    const { register, handleSubmit, errors } = useForm();
    const submitRef = useRef();
    const level = new Array(22).fill("");
    const [state_input, setstate_input] = useState(false);
    let isOption = false;

    useEffect(() => {
        setstate_input(false);
    }, [id])

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t(id ? "edit" : "create")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            disabled={props.isDisabled}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("title")}</label>
                                    <input name="title" type="text" className="form-control-alternative form-control" defaultValue={title}
                                        ref={register({ required: true })} maxLength={100} />
                                    {errors.title && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <label className="form-control-label">{props.t("sectionType")}</label>
                                <div className="form-group" style={{ fontSize: 14 }}>
                                    <input type="radio" name="sectionType" value="0" defaultChecked={sectionType === 0 || !sectionType} ref={register({ required: true })} /> {props.t("chapter")}
                                    <input type="radio" name="sectionType" value="1" defaultChecked={sectionType === 1} ref={register({ required: true })} style={{marginLeft:"20px"}} /> {props.t("lesson")}
                                    <input type="radio" name="sectionType" value="2" defaultChecked={sectionType === 2} ref={register({ required: true })} style={{marginLeft:"20px"}} /> {props.t("section")}
                                    {errors.sectionType && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("level")}</label>
                                    {state_input ?
                                        <input name="chineseLevelInput" type="text" className="form-control-alternative form-control"
                                            ref={state_input ? register({ 
                                                required: true
                                            }) : register} maxLength={100} />
                                        : 
                                        <select name="chineseLevel" className="form-control-alternative form-control" defaultValue={chineseLevel} disabled={props.isDisabled} onChange={(e) => {if(e.target.value === props.t("custom")) setstate_input(true);}}
                                            ref={!state_input ? register({ 
                                                required: true 
                                            }) : register} >
                                            <option value="" selected={!chineseLevel} style={{ display: "none" }}>{props.t("selectLevel")}</option>
                                            {level.map((item, i) => {
                                                if (props.t("level" + i) === chineseLevel) {
                                                    isOption = true;
                                                }
                                                return <option selected={isOption} key={props.t("level" + i)} value={props.t("level" + i)}>{props.t("level" + i)}</option>
                                            })}
                                            <option key={props.t("custom")} value={props.t("custom")}>{props.t("custom")}</option>
                                            {chineseLevel && !isOption && <option key={chineseLevel} selected value={chineseLevel}>{chineseLevel}</option>}
                                        </select>
                                    }
                                    {(errors.chineseLevelInput || errors.chineseLevel) && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        {/*  AIC-9-311 隐藏共享习题集的功能
                        <div className="row">
                            <div className="col-lg-12">
                                <label className="form-control-label">{props.t("share")}</label>
                                <div className="form-group" style={{ fontSize: 14 }}>
                                    <input type="radio" name="visibility" value="0" defaultChecked={visibility === 0 || !visibility} ref={register({ required: true })} /> {props.t("isShare")}
                                    <input type="radio" name="visibility" value="1" defaultChecked={visibility === 1} ref={register({ required: true })} style={{marginLeft:"20px"}} /> {props.t("noShare")}
                                    {errors.visibility && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partnerId: state.session.partner ? state.session.partner.id : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveAsync: vo => dispatch(Actions.saveAsync(vo)),
        create: () => dispatch(Actions.create())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));